import { useState, useEffect } from "react";
import "./QuestionSelector.css";
import { QuestionType } from "effno-core";
import { FormQuestionDeleteModal } from "../form-question/FormQuestionDeleteModal";
import { QuestionTypeSelect } from "../question-settings/QuestionTypeSelect";

type QuestionSelectorProps = {
    defaultValue: QuestionType;
    onChange: (value: QuestionType) => void;
}

export const QuestionSelector = ({defaultValue, onChange} : QuestionSelectorProps) => {

    const [value, setValue] = useState<string>(defaultValue);

    // console.log("[QuestionSelector] value: ", value);
    return (
        
            <QuestionTypeSelect selected={defaultValue} onChange={onChange} />
            // <div className="question-selector">
            //     <select 
            //         onChange={(e: any)=> onChange(e.target.value)}
            //         value={value}
            //     >
            //         <option value={QuestionType.SHORT}>Short</option>
            //         <option value={QuestionType.LONG}>Long</option>
            //         <option value={QuestionType.MULTIPLE}>Multiple</option>
            //         <option value={QuestionType.EMAIL}>Email</option>
            //         <option value={QuestionType.WEBSITE}>Website</option>
            //         <option value={QuestionType.DATE}>Date</option>
            //         <option value={QuestionType.FILE_UPLOAD}>File Upload</option>
            //         <option value={QuestionType.NUMBER}>Number</option>
            //         <option value={QuestionType.PHONE}>Phone</option>
            //         {/* <option value={QuestionType.CHECKBOX}>Checkbox</option> */}
            //         {/* <option value={QuestionType.TIME}>Time</option> */}
            //         <option value={QuestionType.CONTACT}>Contact</option>
            //         <option value={QuestionType.NPS}>NPS</option>
            //         <option value={QuestionType.SCORE}>Score</option>
            //         <option value={QuestionType.RATING}>Rating</option>
            //         <option value={QuestionType.SECTION}>Section</option>
            //         <option value={QuestionType.END}>End</option>
            //     </select>
            // </div>
        
    )
}